import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

import { selectCancellationCandidates } from 'store/subscriptions/selectors';

import { sendAnalyticCancelOfferClick } from 'services/Analytics';

import useModals from 'modals/hooks';
import { useSelector } from 'hooks';
import useCancelSubscriptionFlow from '../../../hooks/useCancelSubscriptionFlow';

import { getValuesByKey } from 'helpers/utils';

import { ModalName } from 'modals/types';

import Modal from 'components/Modal';
import InstallAppSteps from 'components/InstallAppSteps';
import OutlinedButton from 'components/Buttons/OutlinedButton';
import FullScreenModalHeader from '../../components/FullScreenModalHeader';

import { CancelFlowOffers, CancelOfferAction } from 'types/subscription';

import * as S from './styles';

const offer = CancelFlowOffers.Login;

const CanNotLoginModal = () => {
    const { t } = useTranslation();
    const { closeModal, openModal } = useModals();
    const cancellationCandidates = useSelector(selectCancellationCandidates);

    const { onCancelSubscription } = useCancelSubscriptionFlow();

    const subscription_id = getValuesByKey(cancellationCandidates, 'external_id');

    const onBackButtonClick = () => {
        sendAnalyticCancelOfferClick({ eventLabel: { subscription_id, offer }, actionEvent: CancelOfferAction.Close });

        openModal(ModalName.CancellationReasonModal);
    };

    const onClose = useCallback(() => {
        sendAnalyticCancelOfferClick({ eventLabel: { subscription_id, offer }, actionEvent: CancelOfferAction.Close });

        closeModal();
    }, [closeModal, subscription_id]);

    return (
        <Modal
            fullscreen
            isOpen
            customStyles={{ padding: 0, display: 'flex', flexDirection: 'column' }}
            withRoundedCorners={false}
        >
            <FullScreenModalHeader closeModal={onClose} onBackButtonClick={onBackButtonClick} />

            <S.Container>
                <Text medium center mb={12} type="h4">
                    {t('cancellationReasons.canNotLogin.modal.title')}
                </Text>
                <Text center mb={32} type="large-text">
                    {t('cancellationReasons.canNotLogin.modal.subtitle')}
                </Text>

                <InstallAppSteps
                    downloadButtonText="cancellationReasons.canNotLogin.modal.goToApp"
                    cancelOfferName={offer}
                />

                <S.CancelSubscriptionButton>
                    <OutlinedButton
                        onClick={() => {
                            sendAnalyticCancelOfferClick({
                                eventLabel: { subscription_id, offer },
                                actionEvent: CancelOfferAction.Cancel,
                            });
                            onCancelSubscription();
                        }}
                        text={t('basics.button.cancelSubscription')}
                        backgroundColor="surface-main"
                        dataLocator="helpLoginCancelSubscriptionButton"
                    />
                </S.CancelSubscriptionButton>
            </S.Container>
        </Modal>
    );
};

export default CanNotLoginModal;
